import FormTrab from './FormTrab/FormTrab';
import FormProv from './FormProv/FormProv';
import FormDir from './FormDir/FormDir';
import FormTravel from './FormTravel/FormTravel'
import FormGift from './FormGift/FormGift'

export const FormTrabPage = FormTrab;
export const FormProvPage = FormProv;
export const FormDirPage = FormDir;
export const FormTravelPage = FormTravel
export const FormGiftPage = FormGift